export default __webpack_public_path__ + "static/media/boxtype9.36bdc477.JPG";